import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { MyAccountComponent } from './my-account.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { MyWalletComponent } from './my-wallet/my-wallet.component';
import { TransactionsHistoryComponent } from './transactions-history/transactions-history.component';
import { PaymentMethodsComponent } from './payment-methods/payment-methods.component';
import { MyAccountRoutingModule } from './my-account-routing.module';
import { HeaderComponent } from './header/header.component';
import { CampaignPaymentTransactionHistoryModal } from './campaign-payment-transaction-history-modal/campaign-payment-transaction-history-modal.component';
import { SupplierDetailedChargesTransactionHistoryModal } from './supplier-detailed-charges-transaction-history-modal/supplier-detailed-charges-transaction-history-modal.component';

@NgModule({
    declarations: [
        HeaderComponent,
        MyAccountComponent,
        MyProfileComponent,
        MyWalletComponent,
        CampaignPaymentTransactionHistoryModal,
        SupplierDetailedChargesTransactionHistoryModal,
        TransactionsHistoryComponent,
        PaymentMethodsComponent
    ],
    imports: [CommonModule, MyAccountRoutingModule, SharedModule],
    providers: []
})
export class MyAccountModule {}
